import type { ReactNode } from 'react';

export const symbol_airline_seat_legroom_reduced: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M627-120q-27.43 0-46.71-23Q561-166 568-192l55-218H320q-28.87 0-49.44-20.56Q250-451.13 250-480v-330q0-12.75 8.63-21.38Q267.25-840 280-840h160q12.75 0 21.38 8.62Q470-822.75 470-810v220h230q30 0 48 23.5t10 52.5l-84 294h74q22.65 0 37.32 13.75Q800-192.5 800-170t-13.75 36.25Q772.5-120 750-120H627ZM180-280q-24.75 0-42.37-17.63Q120-315.25 120-340v-470q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v470h270q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H180Z"
		/>
	</svg>
);
